import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../services/firebase";
import { ref, get } from "firebase/database";
import "./TeacherStatus.css"; // 👉 custom CSS for styling

function TeacherStatus() {
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Load teacher from localStorage on first render
  useEffect(() => {
    const saved = localStorage.getItem("teacher");
    if (saved) {
      setTeacher(JSON.parse(saved));
    }
    setLoading(false);
  }, []);

  // 🔄 Function to re-check teacher status from Firebase
  const checkStatus = async () => {
    if (!auth.currentUser) {
      navigate("/teacher-login");
      return;
    }

    setLoading(true);
    try {
      const teacherRef = ref(db, "teacherRegistrations/" + auth.currentUser.uid);
      const snapshot = await get(teacherRef);

      if (snapshot.exists()) {
        const updated = snapshot.val();
        localStorage.setItem("teacher", JSON.stringify(updated));
        setTeacher(updated);

        if (updated.status === "approved") {
          navigate("/teacher-dashboard"); // ✅ Move to dashboard if approved
        }
      }
    } catch (err) {
      console.error("Error checking status:", err);
    }
    setLoading(false);
  };

  if (loading) return <p>Loading dashboard...</p>;
  if (!teacher) return <p>No teacher data found. Please login again.</p>;

  return (
    <div className="tp-container">
      {/* Header */}
      <div className="tp-header">
        <h2>⏳ Approval Pending</h2>
        <p>Your registration is under administrator review.</p>
      </div>

      {/* Profile Card */}
      <div className="tp-profile-card">
        <div className="tp-profile-avatar">
          {(teacher.firstName || teacher.name || "T")[0].toUpperCase()}
        </div>
        <div>
          <h3>{teacher.firstName || teacher.name} {teacher.lastName}</h3>
          <p>{teacher.email}</p>
          <span className="tp-status-badge">Awaiting Approval</span>
        </div>
      </div>

      {/* Info Cards */}
      <div className="tp-info-section">
        {/* Account Details */}
        <div className="tp-card">
          <h4>📌 Account Details</h4>
          <p><strong>Name:</strong> {teacher.firstName || teacher.name || "N/A"} {teacher.lastName || ""}</p>
          <p><strong>Email:</strong> {teacher.email || "N/A"}</p>
          <p><strong>University:</strong> {teacher.university || teacher.college || "N/A"}</p>
          <p><strong>Designation:</strong> {teacher.designation || "N/A"}</p>
          <p><strong>Role:</strong> {teacher.role || "Teacher"}</p>
          <p><strong>Phone:</strong> {teacher.phone || "N/A"}</p>
          <p><strong>Registration Date:</strong> {teacher.createdAt || "N/A"}</p>
        </div>

        {/* Process Timeline */}
        <div className="tp-card tp-timeline-card">
          <h4>🗂 Process Timeline</h4>
          <ul>
            <li className="tp-done">✔ Registration Submitted</li>
            <li className="tp-active">⏳ Admin Review (In Progress)</li>
            <li>📧 Email Notification (Pending)</li>
            <li>🔓 Account Activation (Pending)</li>
          </ul>
          <div className="tp-timeline-footer">
            <span>Estimated Time: 1–2 business days</span>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="tp-actions">
        <button onClick={checkStatus} className="tp-btn tp-check">
          🔄 Check Approval Status
        </button>
        <button onClick={() => navigate("/support")} className="tp-btn tp-contact">
          📩 Contact Admin
        </button>
        <button
          onClick={() => {
            localStorage.removeItem("teacher");
            navigate("/teacher-login");
          }}
          className="tp-btn tp-signout"
        >
          🚪 Sign Out
        </button>
      </div>
    </div>
  );
}

export default TeacherStatus;
